<template>
    <div class="ArticlClassify-box">
        <!-- <el-button size="mini" @click="handleEdit(scope.$index, scope.row)" class='addArticl'>新增文章类型</el-button> -->
        <el-table :data="tableData1" style="width: 100%" row-key='name' border ref='problemTable' v-loading="loading"
            :tree-props="{children: 'children', hasChildren: 'hasChildren'}" v-if='vif'>
            <el-table-column prop="name" label="问题类型" width="180">
            </el-table-column>
            <el-table-column prop="answer" label="问题解答">
            </el-table-column>
            <el-table-column label="操作" width="180">
                <template slot-scope="scope">
                    <el-button size="mini" v-if='scope.row.description' @click='addProblem(scope.$index, scope.row)'>
                        新增</el-button>
                    <el-button size="mini" @click="reatch(scope.row)" v-if='scope.row.answer'>
                        编辑</el-button>
                    <el-button size="mini" type="danger" @click="deleteProblem(scope.$index, scope.row)"
                        v-if='scope.row.answer'>删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 提示box -->
        <el-dialog title="提示" :visible.sync="centerDialogVisible" width="30%" center :before-close="handleClose">
            <span class="problemname">问题描述：</span>
            <el-input type="text" placeholder="SEO描述，默认可不填" v-model="problemChildData.problem" maxlength="300" autofocus
                show-word-limit></el-input>
            <span class="problemname">问题解答：</span>
            <el-input type="textarea" placeholder="SEO描述，默认可不填" v-model="problemChildData.problemValue" maxlength="300"
                autofocus show-word-limit></el-input>
            <span slot="footer" class="dialog-footer">
                <el-button @click="ClossAdd">取 消</el-button>
                <el-button type="primary" @click="myBootm">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    export default {
        name: 'ArticlClassify',
        data() {
            return {
                tableData1: [],//问题分类
                childTableData: [],//子问题
                parentTable: [],//中转站
                numbsum: 0,//计数器
                centerDialogVisible: false,
                loading: true,//loading
                vif: true,
                AddorRecr: true,//新增或者编辑
                problemChildData: {
                    problemid: '',
                    problem: '',
                    problemValue: '',
                    mainId: ''
                }
            }
        },
        mounted() {
            this.getProblem()
        },
        methods: {
            addProblem(num, item) {//新增问题
                this.AddorRecr = true
                this.centerDialogVisible = true
                this.problemChildData.problemid = item.id
            },
            upProblem() {//提示内容
                let value = this.problemChildData.problem
                this.$confirm(`您要新增的问题是:${value}，对吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    beforeClose: (action, instance, done) => {
                        if (action === 'confirm') {
                            instance.confirmButtonLoading = true;
                            instance.confirmButtonText = '执行中...';
                            this.promaxios()
                            setTimeout(() => {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                    this.problemChildData.problem = ''
                                    this.problemChildData.problemValue = ''
                                }, 300);
                            }, 3000);
                        } else {
                            done();
                        }
                    }
                }).then(() => {
                    console.log('添加成功')
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消添加'
                    });
                });
            },
            promaxios() {//新增问题
                let fromdata = new FormData()
                fromdata.set('problem', this.problemChildData.problem)
                fromdata.set('answer', this.problemChildData.problemValue)
                fromdata.set('problem_type_id', this.problemChildData.problemid)
                this.$getToken.post(this.$API.addProblem, fromdata)
                    .then(res => {
                        this.$message({
                            type: 'success',
                            message: '添加成功'
                        });
                    })
                    .catch(err => {
                        console.log(err)
                    })
            },
            getProblem() {//获取问题总列表
                this.$getToken.get(this.$API.getProblem)
                    .then(res => {
                        this.parentTable = res.data.data
                        this.lookProblem(res.data.data)//获取所有子问答列表
                        // this.tableData1 = promblemData
                    })
                    .catch(err => {
                        console.log(err)
                    })
            },
            lookProblem(arr) {//获取问答列表
                if (this.numbsum < arr.length) {
                    this.$getToken.get(this.$API.lookProblem(arr[this.numbsum].id))
                        .then(res => {
                            let problemArr = res.data.data
                            let newProbleArr = []
                            for (let i in problemArr) {
                                let obj = {}
                                obj.id = problemArr[i].id
                                obj.name = problemArr[i].problem
                                obj.answer = problemArr[i].answer
                                obj.problem_type_id = problemArr[i].problem_type_id
                                newProbleArr.push(obj)
                            }
                            this.parentTable[this.numbsum].children = newProbleArr
                            this.numbsum += 1
                            this.lookProblem(this.parentTable)
                        })
                        .catch(err => {
                            console.log(err)
                        })
                } else {
                    this.tableData1 = this.parentTable
                    this.numbsum = 0
                    this.parentTable = []
                    this.loading = false
                }
            },
            deleteProblem(i, item) {//删除问题
                this.$confirm('此操作将永久删除该问题, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$message({
                        type: 'success',
                        message: '正在删除请稍后......'
                    });
                    this.$getToken.delete(this.$API.deleteProblem(item.problem_type_id), {
                        params: {
                            "ids[]": item.id
                        }
                    })
                        .then(res => {
                            this.loading = true
                            this.getProblem()
                            this.$message.success('删除成功')
                        })
                        .catch(err => {
                            this.$message.error('删除失败')
                        })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            deleteData(id, childid) {
                let prantplace, childplace
                for (let i in this.tableData1) {//查找传入id的分类位置
                    if (this.tableData1[i].id === id) {
                        prantplace = i
                        for (let j in this.tableData1[i].children) {
                            if (this.tableData1[i].children[j].id === childid) {
                                childplace = j
                            }
                        }
                    }
                }
                if (prantplace && childplace) {
                    this.tableData1[prantplace].children.splice(this.tableData1[prantplace].children[childplace], 1)
                    console.log(this.tableData1)
                }
            },
            changea() {//刷新表单
                this.vif = !this.vif
                let _this = this
                setTimeout(() => {
                    _this.vif = !_this.vif
                }, 300)
                // this.$refs.problemTable.toggleRowExpansion(this.tableData1[prantplace],false)
            },
            handleClose(done) {//关闭前的回调
                done();
                this.ClossAdd()
            },
            ClossAdd() {//关闭新增
                this.centerDialogVisible = false
                this.loading = true
                this.getProblem()
                this.changea()
            },
            reatch(item) {//进入编辑
                this.problemChildData.problemid = item.id
                this.problemChildData.problem = item.name
                this.problemChildData.problemValue = item.answer
                this.problemChildData.mainId = item.problem_type_id
                this.AddorRecr = false
                this.centerDialogVisible = true
            },
            myBootm() {//确认&编辑按钮
                if (this.AddorRecr) {//新增
                    this.upProblem()
                } else {//编辑
                    this.upreatch()
                }
            },
            upreatch() {//编辑
                this.$confirm(`您确定要编辑该内容吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    beforeClose: (action, instance, done) => {
                        if (action === 'confirm') {
                            instance.confirmButtonLoading = true;
                            instance.confirmButtonText = '执行中...';
                            this.reactaxios()
                            setTimeout(() => {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                    this.problemChildData.problemid = ''
                                    this.problemChildData.problem = ''
                                    this.problemChildData.problemValue = ''
                                    this.problemChildData.mainId = ''
                                    this.ClossAdd()
                                }, 300);
                            }, 3000);
                        } else {
                            done();
                        }
                    }
                }).then(() => {
                    console.log('编辑成功')
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消编辑'
                    });
                });
            },
            reactaxios() {
                // let fromdata = new FormData()
                // fromdata.set('problem', this.problemChildData.problem)
                // fromdata.set('answer', this.problemChildData.problemValue)
                // fromdata.set('problem_type_id', this.problemChildData.mainId)
                this.$getToken.put(this.$API.reactProblem(this.problemChildData.problemid),this.$qs.stringify(
                    {
                        problem: this.problemChildData.problem,
                        answer: this.problemChildData.problemValue,
                        problem_type_id: this.problemChildData.mainId 

                    }, { indices: true }))
                    .then(res => {
                        this.$message({
                            type: 'success',
                            message: '编辑成功'
                        });
                    })
                    .catch(err => {
                        console.log(err)
                    })
            }
        }
    }
</script>
<style scoped>
    .ArticlClassify-box {
        height: 800px;
        overflow-y: auto;
    }

    .addArticl {
        margin-bottom: 20px;
    }

    .problemname {
        display: block;
        margin: 10px 0;
        font-size: 14px;
        font-weight: bold;
    }
</style>


// WEBPACK FOOTER //
// src/components/admin/articlclassify.vue